/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:7ddd9ba5-5343-430e-94b2-424df9c5405d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_5CdfmAVPm",
    "aws_user_pools_web_client_id": "2unuuqlrfpfa0r7vilah788v14",
    "oauth": {
        "domain": "midwayauth-ispprod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.isp-revoke-purchase.alexa.amazon.dev/,https://isp-revoke-purchase.alexa.amazon.dev/",
        "redirectSignOut": "http://localhost:3000/,https://www.isp-revoke-purchase.alexa.amazon.dev/,https://isp-revoke-purchase.alexa.amazon.dev/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
